import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35565ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "row",
  style: {"gap":"20px"}
}
const _hoisted_5 = {
  class: "col-10 d-flex flex-column justify-content-center align-items-center",
  style: {"gap":"50px"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Servicios a Aeronaves")
], -1))
const _hoisted_8 = { class: "row mb-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Fecha Inicial", -1))
const _hoisted_10 = { class: "col-sm-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Fecha Final", -1))
const _hoisted_12 = { class: "col-sm-3" }
const _hoisted_13 = { class: "row mb-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Compañía", -1))
const _hoisted_15 = { class: "col-sm-5" }
const _hoisted_16 = { selected: "" }
const _hoisted_17 = ["value"]

import { ref, watch, computed,onMounted } from 'vue'
import axios from 'axios';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';
import { useDateTimeStore } from '@/store/dateTimeStore';
import CarCoaer from './CarCoaer.vue';
import { Cartarvue } from '@/interface/interfaces';
import ExRegSerAero from './pImpresion/ExRegSerAero.vue';
import { isReturnStatement } from 'typescript';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExResSerAero',
  setup(__props) {

const { success, error, question, warning } = useAlert()
const dUrl = UrlGlobal()
const userStore = userGlobalStore()
const dateTimeStore = useDateTimeStore();

const onlyRead = ref(true);
onlyRead.value = true
//--------------------------------------------------------------------------------------------------------------
// Estado del formulario y la data
const formData = ref({
  fecha_inicial: '',
  fecha_final: '',
  compania: '',
  aeronave: '',
});

const envio_data = computed(() => ({
  fecha_inicial: formData.value.fecha_inicial,
  fecha_final: formData.value.fecha_final,
  compania: formData.value.compania,
   
}));

const generateExcel = async () => {
  if (!formData.value.fecha_inicial) {
    error('Digite la fecha inicial del resumen...')
    return
  }
  if (!formData.value.fecha_final) {
    error('Debe digitar la fecha final del resumen...')
    return
  }

  if (formData.value.fecha_inicial > formData.value.fecha_final) {
    error('Fecha inicial del resumen es mayor a la fecha final...')
    return
  }
  
  try {
    const response = await axios.post(
      dUrl.urlGlobal + '/api2/Caratvue_excel_resumen',
      envio_data.value,
      { responseType: 'blob' }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'serv_aereos_resumen.xlsx');
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al generar el manifiesto:', error);
  }
};
//----------------------------------------------------------------
const Salir = () => {
  let i = 0

};
//carga de las ayudas
const aeronaves = ref<any[]>([]);
const companias = ref<any[]>([]);
onMounted(async () => {
  const responseA = await axios.get(dUrl.urlGlobal + '/api2/cartiaero/')
  aeronaves.value = responseA.data
  const responseP = await axios.get(dUrl.urlGlobal + `/api2/compania/filter?status=A`)
  companias.value = responseP.data

//computados de las ayudas
const descripcionAeronaves = computed(() => {
  const encontrado = aeronaves.value.find(i => i.aeronave === formData.value.aeronave)
  return encontrado ? encontrado.descripcion : ''
})

const descripcionCompania = computed(() => {
  const encontrado = companias.value.find(i => i.compania === formData.value.compania)
  return encontrado ? encontrado.nombre : ''
})
});
//---------------------------------------------------------------------------

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("form", null, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        type: "date",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.fecha_inicial) = $event))
                      }, null, 512), [
                        [_vModelText, formData.value.fecha_inicial]
                      ])
                    ]),
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        type: "date",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.fecha_final) = $event))
                      }, null, 512), [
                        [_vModelText, formData.value.fecha_final]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.compania) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.descripcionCompania), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companias.value, (i) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: i.compania,
                            value: i.compania
                          }, _toDisplayString(i.nombre), 9, _hoisted_17))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, formData.value.compania]
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "col",
              style: {"background-color":"rgba(255, 255, 255, 0.3)","backdrop-filter":"blur(10px)","border-radius":"10px"}
            }, [
              _createElementVNode("div", { class: "btn-group2" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light btn-sm",
                  onClick: generateExcel
                }, "Generar Excel"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light btn-sm",
                  onClick: Salir
                }, "Cancelar")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})